import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui';
import { useAuth } from '@/contexts/AuthContext';

export default function BillingSuccessPage() {
  const { refreshOrganizations } = useAuth();

  useEffect(() => {
    // Reload org so subscription.plan / status reflect the new Stripe subscription
    refreshOrganizations().catch(console.error);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="w-16 h-16 rounded-full bg-status-success-bg flex items-center justify-center">
            <CheckCircle2 className="w-8 h-8 text-status-success" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">Subscription activated!</h1>
          <p className="text-muted-foreground">
            Your plan has been upgraded. All new features are now available.
          </p>
        </div>

        <Button asChild variant="default">
          <Link to="/">Go to Dashboard</Link>
        </Button>
      </div>
    </div>
  );
}
